export default "__VITE_ASSET__DvDmpM7l__"